export const NEEDS_REVIEW_REASONS = [
    { name: 'AB5', label: 'AB5' },
    { name: 'BadHolidayMultiplier', label: 'Bad Holiday Multiplier' },
    { name: 'CallbackDocumentationtRequired', label: 'Callback Doc Required' },
    { name: 'CallRateNotEntered', label: 'Call Rate Not Entered' },
    { name: 'EmptyRawTimesheet', label: 'Empty Raw Timesheet' },
    { name: 'FacilityTimesheetRequired', label: 'Facility Timesheet Required' },
    { name: 'HolidayExceptionNotes', label: 'Holiday Exception Notes' },
    { name: 'HolidayExpected', label: 'Holiday Expected' },
    { name: 'HolidayNotExpected', label: 'Holiday Not Expected' },
    { name: 'InvalidExpensePayor', label: 'Invalid Expense Payor' },
    { name: 'InvalidRateConfiguration', label: 'Invalid Rate Configuration' },
    { name: 'InvalidRequestData', label: 'Invalid Request Data' },
    { name: 'InvalidThreshold', label: 'Invalid Threshold' },
    { name: 'InvalidTrigger', label: 'Invalid Trigger' },
    { name: 'IsCorrection', label: 'Is Correction' },
    { name: 'UnderMargin', label: 'Low Bill / Pay Margin' },
    { name: 'MileageNotExpected', label: 'Mileage Not Expected' },
    { name: 'MissingClinicianData', label: 'Missing Clinician Data' },
    { name: 'MissingMailingAddress', label: 'Missing Mailing Address' },
    { name: 'MissingMileageRate', label: 'Missing Mileage Rate' },
    { name: 'MissingTimesheetImage', label: 'Missing Timesheet Image' },
    { name: 'Multiple24HourCallOnDay', label: 'Multiple 24 Hour Call On Day' },
    { name: 'NoActiveRateSet', label: 'No Active Rate Set' },
    { name: 'NoGuaranteedHrsAdjustment', label: 'No Guaranteed Hrs Adjustment' },
    { name: 'OnsiteConsultAdded', label: 'Onsite Consult Added' },
    { name: 'OverThreshold', label: 'Over Bill / Pay Threshold' },
    { name: 'OverlappingEffectiveDates', label: 'Overlapping Effective Dates' },
    { name: 'OverlappingRateSets', label: 'Overlapping Rate Sets' },
    { name: 'OvertimeDocumentationtRequired', label: 'Overtime Doc Required' },
    { name: 'PaperTimesheet', label: 'Paper Timesheet' },
    { name: 'HasRateExceptionNotes', label: 'Rate Exception Notes' },
    { name: 'RateNotFound', label: 'Rate Not Found' },
    { name: 'RegularHoursOn24HourCall', label: 'Regular Hours On 24 Hour Call' },
    { name: 'RequiresConfirmationOfAssignment', label: 'Requires Booking Confirmation' },
    { name: 'RequiresManualProcessing', label: 'Requires Manual Processing' },
    { name: 'RequiresMileageVerification', label: 'Requires Mileage Verification' },
    { name: 'HasComment', label: 'Timesheet Has Comment' },
    { name: 'TimesheetNotExpected', label: 'Timesheet Not Expected' },
    { name: 'UnableToProcessTimesheet', label: 'Unable To Process Timesheet' },
    { name: 'UnapprovedWorkLocation', label: 'Unapproved Work Location' },
    { name: 'UnderThreshold', label: 'Under Bill / Pay Threshold' },
    { name: 'UnderGuaranteedThreshold', label: 'Under Guaranteed Threshold' },
    { name: 'UnknownInvEngIssueCode', label: 'Unknown Invoice Engine Issue Code' },
    { name: 'UnknownRateType', label: 'Unknown Rate Type' },
    { name: 'UnknownTriggerType', label: 'Unknown Trigger Type' },
    { name: 'UnknownUnitType', label: 'Unknown Unit Type' },
    { name: 'UnknownWorkLocation', label: 'Unknown Work Location' },
];

export const PROCESSED_TIMESHEET_STATUS_ENUM = {
    AutomaticallyProcessed: 'AutomaticallyProcessed',
    NeedsReview: 'NeedsReview',
    Resolved: 'Resolved',
    Cancelled: 'Cancelled',
    Creating: 'Creating',
    Errored: 'Errored',
    WorkdayError: 'WorkdayError',
    Posted: 'Posted',
    Outdated: 'Outdated',
    Invoiced: 'Invoiced',
    InvoiceReview: 'InvoiceReview',
    PayImpactOnly: 'PayImpactOnly',
    NoBPImpact: 'NoBPImpact',
};

export const PROCESSED_TIMESHEET_STATUSES = {
    [PROCESSED_TIMESHEET_STATUS_ENUM.AutomaticallyProcessed]: {
        description: 'AUTO PROCESSED',
        color: 'info',
    },
    [PROCESSED_TIMESHEET_STATUS_ENUM.NeedsReview]: {
        description: 'NEEDS REVIEW',
        color: 'warning',
    },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Resolved]: { description: 'RESOLVED', color: 'success' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Cancelled]: { description: 'CANCELLED', color: 'default' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Creating]: { description: 'CREATING', color: 'default' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Errored]: { description: 'ERRORED', color: 'error' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.WorkdayError]: {
        description: 'WORKDAY ERROR',
        color: 'default',
    },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Posted]: { description: 'POSTED', color: 'success' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Outdated]: { description: 'OUTDATED', color: 'grey' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.Invoiced]: { description: 'INVOICED', color: 'success' },
    [PROCESSED_TIMESHEET_STATUS_ENUM.InvoiceReview]: {
        description: 'INVOICE REVIEW',
        color: 'inReview',
    },
    [PROCESSED_TIMESHEET_STATUS_ENUM.PayImpactOnly]: {
        description: 'PAY IMPACT ONLY',
        color: 'success',
    },
    [PROCESSED_TIMESHEET_STATUS_ENUM.NoBPImpact]: { description: 'NO BP IMPACT', color: 'success' },
    // Sub statuses
    TCReview: { description: 'TC REVIEW', color: 'warning' },
    TCHold: { description: 'TC HOLD', color: 'error' },
    TCError: { description: 'TC ERROR', color: 'error' },
    BPReview: { description: 'BP REVIEW', color: 'warning' },
    BPQuestion: { description: 'BP QUESTION', color: 'error' },
    BPError: { description: 'BP ERROR', color: 'error' },
};
// Returns a dictionary of status labels. This way you can get the label with PROCESSED_TIMESHEET_STATUS_LABELS["TCReview"]
export const PROCESSED_TIMESHEET_STATUS_LABELS = Object.keys(PROCESSED_TIMESHEET_STATUSES).reduce(
    (acc, status) => {
        acc[status] = PROCESSED_TIMESHEET_STATUSES[status].description;
        return acc;
    },
    {}
);
// Returns a dictionary of status colors. This way you can get the color with PROCESSED_TIMESHEET_STATUS_COLORS["TCReview"]
export const PROCESSED_TIMESHEET_STATUS_COLORS = Object.keys(PROCESSED_TIMESHEET_STATUSES).reduce(
    (acc, status) => {
        acc[status] = PROCESSED_TIMESHEET_STATUSES[status].color;
        return acc;
    },
    {}
);

export const SPECIAL_PROCESSING_OPTIONS = [
    'Ascension - DocTime',
    'BSMH',
    'Client Portal',
    'Client Portal V2',
    'Fairview',
    'Fieldglass - Corewell',
    'Healthtrust',
    'HWL',
    'Knowledge Services',
    'Kronos',
    'LocumsMart',
    'NAPA - Ringo',
    'Parkview - DocTime',
    'Trio - AHSA',
    'Trio - CommonSpirit',
    'Trio - Envision',
    'Trio - StratumMed',
    'UPMC',
    'VA DOC',
    'Venn - ARH',
    'Venn - Baptist',
    'Venn - BHD',
    'Venn – Corewell',
    'Venn - Deaconess',
    'Venn - Guthrie',
    'Venn – INTEGRIS',
    'Venn - Norton',
    'VMS',
    'WAND - Fairview',
    'WAND - Intermountain',
    'WAND - Mayo',
    'WAND - USAP',
];

export const EXCLUDE_SPECIAL_PROCESSING = 'ExcludeSpecialProcessing';

/**
 * Special Processing include values and Exclude Special Processing cannot be
 * applied at the same time.
 *
 * Conflict handling (Timesheet Management, Processed Timesheets, and Expense
 * Management):
 * - Exclude Special Processing is the first option in the list.
 * - Selecting Exclude clears every include value via each option's `exclude` array.
 * - Selecting any include value clears Exclude.
 * - API serialization sends ExcludeSpecialProcessing=true and omits SpecialProcessing
 *   include params (the API returns 400 if both are sent).
 */
export const specialProcessingFilterOptions = [
    {
        label: 'Exclude Special Processing',
        value: EXCLUDE_SPECIAL_PROCESSING,
        exclude: SPECIAL_PROCESSING_OPTIONS,
    },
    ...SPECIAL_PROCESSING_OPTIONS.map((option) => ({
        label: option,
        value: option,
        exclude: [EXCLUDE_SPECIAL_PROCESSING],
    })),
];
